<template>
  <VueTelInput
    :id="id"
    :ref="() => telephoneInput = refId"
    v-model="localValue"
    :default-country="$i18n.localeProperties.value.countryCode"
    valid-characters-only
    mode="international"
    :input-options="{
      name,
      placeholder: 'Your phone number' + (!props.isOptional ? ' (optional)' : ''),
    }"
    :class="bem()"
    @validate="handleValidate"
    @open="countryDropdownOpen = true"
    @close="countryDropdownOpen = false"
  >
    <template #arrow-icon>
      <span class="vti__dropdown-arrow">
        {{ countryDropdownOpen ? '▲' : '▼' }}
      </span>
    </template>
  </VueTelInput>
</template>

<script setup>
import { VueTelInput } from 'vue-tel-input'

const props = defineProps({
  id: { type: String, default: '', required: true },
  name: { type: String, default: '' },
  isOptional: { type: Boolean, required: false, default: false }
})

const emit = defineEmits([ 'update:modelValue', 'isValid' ])

const bem = useBEM('TelephoneInput')

const localValue = ref('')
const countryDropdownOpen = ref(false)
const telephoneInput = ref()

const refId = computed(() => {
  return 'telephone-' + props.id
})

function handleValidate (e) {
  emit('isValid', e.valid)
}

watch(() => localValue.value, (newValue) => {
  emit('update:modelValue', newValue)
})
</script>

<style lang="postcss">
@import 'vue-tel-input/vue-tel-input.css';

.TelephoneInput {
  @apply rounded-md bg-grey-light border-transparent pt-3 pb-3 w-full;

  &:focus-within {
    @apply shadow-none border border-grey;
  }

  .vti__dropdown {
    @apply py-0;
  }

  .vti__input {
    @apply rounded-md bg-grey-light text-sm mr-4;
  }
}
</style>